.navWrapper {
  background-color: var(--color-bg-secondary);
  border-bottom: 1px solid var(--color-border);
  /* Prevent content shift while loading */
  min-height: 44px;
}

.scrollContainer {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none; /* Firefox */
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 16px;
  gap: 4px;
}

.scrollContainer::-webkit-scrollbar {
  display: none;
}

.pill {
  flex-shrink: 0;
  scroll-snap-align: start;
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  background-color: var(--color-category-bg);
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s, color 0.15s;
  margin: 6px 0;
}

.pill:hover {
  background-color: var(--color-border);
  color: var(--color-text-primary);
}

.pill.active {
  background-color: var(--color-category-active);
  color: var(--color-category-active-text);
  font-weight: 600;
}

.skeleton {
  display: flex;
  gap: 8px;
  padding: 10px 16px;
  max-width: 1280px;
  margin: 0 auto;
}

.skeletonPill {
  height: 32px;
  width: 80px;
  border-radius: 20px;
  background-color: var(--color-skeleton);
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.5; }
}
